import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConnectAgodaInstructionsComponent } from '@app/modules/connected-accounts/components/connect-agoda-instructions/connect-agoda-instructions.component';
import { ConnectAgodaMessagingComponent } from '@app/modules/connected-accounts/components/connect-agoda-messaging/connect-agoda-messaging.component';
import { ConnectAgodaPropertyIdsComponent } from '@app/modules/connected-accounts/components/connect-agoda-property-ids/connect-agoda-property-ids.component';
import { ConnectAgodaRequirementsFailComponent } from '@app/modules/connected-accounts/components/connect-agoda-requirements-fail/connect-agoda-requirements-fail.component';
import { ConnectAgodaRequirementsComponent } from '@app/modules/connected-accounts/components/connect-agoda-requirements/connect-agoda-requirements.component';
import { ConnectAgodaReviewPropertiesComponent } from '@app/modules/connected-accounts/components/connect-agoda-review-properties/connect-agoda-review-properties.component';
import { ConnectAgodaStartComponent } from '@app/modules/connected-accounts/components/connect-agoda-start/connect-agoda-start.component';
import { ConnectBookingPricingComponent } from '@app/modules/connected-accounts/components/connect-booking-pricing/connect-booking-pricing.component';
import { DialogWatchVideoComponent } from '@app/modules/connected-accounts/components/dialog-watch-video/dialog-watch-video.component';
import { ConnectAirbnbFlowComponent } from '@app/modules/connected-accounts/pages/connect-airbnb-flow/connect-airbnb-flow.component';
import { SharedModule } from '@app/shared/shared.module';
import { SettingsModule } from '../settings/settings.module';
import { AccountPermissionsPillComponent } from './components/account-permissions-pill/account-permissions-pill.component';
import { CompletionBoxComponent } from './components/completion-box/completion-box.component';
import { ConnectAirbnbPhase4SuccessComponent } from './components/connect-airbnb-phase4-success/connect-airbnb-phase4-success.component';
import { ConnectAirbnbUnofficialPhase1Component } from './components/connect-airbnb-unofficial-phase1/connect-airbnb-unofficial-phase1.component';
import { ConnectAirbnbUnofficialPhase2Component } from './components/connect-airbnb-unofficial-phase2/connect-airbnb-unofficial-phase2.component';
import { ConnectBookingChooseMethodComponent } from './components/connect-booking-choose-method/connect-booking-choose-method.component';
import { ConnectBookingCredentialsComponent } from './components/connect-booking-credentials/connect-booking-credentials.component';
import {
  BookingConnectionDocumentationPipe,
  ConnectBookingDisclaimerComponent,
} from './components/connect-booking-disclaimer/connect-booking-disclaimer.component';
import { ConnectBookingFailComponent } from './components/connect-booking-fail/connect-booking-fail.component';
import { ConnectBookingPropertyIdsComponent } from './components/connect-booking-property-ids/connect-booking-property-ids.component';
import { ConnectBookingQuickSetupDoneComponent } from './components/connect-booking-quick-setup-done/connect-booking-quick-setup-done.component';
import { ConnectBookingQuickSetupPhase1Component } from './components/connect-booking-quick-setup-phase1/connect-booking-quick-setup-phase1.component';
import { ConnectBookingQuickSetupPhase3PropertiesDetailsComponent } from './components/connect-booking-quick-setup-phase3-properties-details/connect-booking-quick-setup-phase3-properties-details.component';
import { ConnectBookingQuickSetupPhase3PropertiesListComponent } from './components/connect-booking-quick-setup-phase3-properties-list/connect-booking-quick-setup-phase3-properties-list.component';
import { ConnectBookingRequirementsFailComponent } from './components/connect-booking-requirements-fail/connect-booking-requirements-fail.component';
import { ConnectBookingReviewPropertiesComponent } from './components/connect-booking-review-properties/connect-booking-review-properties.component';
import { ConnectSetMarkupComponent } from './components/connect-booking-set-markup/connect-booking-set-markup.component';
import { ConnectBookingStartComponent } from './components/connect-booking-start/connect-booking-start.component';
import { ConnectBookingSuccessComponent } from './components/connect-booking-success/connect-booking-success.component';
import { ConnectBookingWidgetPendingComponent } from './components/connect-booking-widget-pending/connect-booking-widget-pending.component';
import { ConnectBookingWidgetComponent } from './components/connect-booking-widget/connect-booking-widget.component';
import { ConnectDoneComponent } from './components/connect-done/connect-done.component';
import { ConnectVrboPhase1Component } from './components/connect-vrbo-phase1/connect-vrbo-phase1.component';
import { ConnectSharedTwofaComponent } from './components/connect-vrbo-phase2-twofa/connect-shared-twofa.component';
import { ConnectVrboPhase3SuccessComponent } from './components/connect-vrbo-phase3-success/connect-vrbo-phase3-success.component';
import { ConnectVrboStartComponent } from './components/connect-vrbo-start/connect-vrbo-start.component';
import { MergeMatchDropdownComponent } from './components/merge-match-dropdown/merge-match-dropdown.component';
import { DialogChannelNotificationsComponent } from './components/dialog-channel-notifications/dialog-channel-notifications.component';
import { ConnectedAccountsRoutingModule } from './connected-accounts-routing.module';
import { AirbnbOfficialConnectionErrorComponent } from './pages/airbnb-official-connection-error/airbnb-official-connection-error.component';
import { ConnectAgodaFlowComponent } from './pages/connect-agoda-flow/connect-agoda-flow.component';
import { ConnectAirbnbOfficialFlowComponent } from './pages/connect-airbnb-official-flow/connect-airbnb-official-flow.component';
import { ConnectBookingFlowComponent } from './pages/connect-booking-flow/connect-booking-flow.component';
import { ConnectBookingQuickSetupFlowComponent } from './pages/connect-booking-quick-setup-flow/connect-booking-quick-setup-flow.component';
import { ConnectCompleteComponent } from './pages/connect-complete/connect-complete.component';
import { ConnectFlowTemplateComponent } from './pages/connect-flow-template/connect-flow-template.component';
import { ConnectInviteYourHostsComponent } from './pages/connect-invite-your-hosts/connect-invite-your-hosts.component';
import { ConnectInviteComponent } from './pages/connect-invite/connect-invite.component';
import { ConnectVrboFlowComponent } from './pages/connect-vrbo-flow/connect-vrbo-flow.component';
import { ConnectedAccountsOverviewComponent } from './pages/connected-accounts-overview/connected-accounts-overview.component';
import { DeniedComponent } from './pages/denied/denied.component';
import { ReviewListingsComponent } from './pages/review-listings/review-listings.component';
import { DowngradeAirbnbComponent } from './pages/downgrade-airbnb/downgrade-airbnb.component';

@NgModule({
  declarations: [
    ConnectedAccountsOverviewComponent,
    DialogChannelNotificationsComponent,
    AccountPermissionsPillComponent,
    ConnectVrboFlowComponent,
    ConnectFlowTemplateComponent,
    ConnectVrboStartComponent,
    ConnectVrboPhase1Component,
    ConnectSharedTwofaComponent,
    ConnectVrboPhase3SuccessComponent,
    ReviewListingsComponent,
    ConnectCompleteComponent,
    DialogWatchVideoComponent,
    CompletionBoxComponent,
    ConnectAirbnbUnofficialPhase1Component,
    ConnectAirbnbUnofficialPhase2Component,
    ConnectAirbnbPhase4SuccessComponent,
    ConnectBookingQuickSetupFlowComponent,
    ConnectBookingQuickSetupPhase1Component,
    ConnectBookingQuickSetupPhase3PropertiesListComponent,
    ConnectBookingQuickSetupPhase3PropertiesDetailsComponent,
    ConnectBookingQuickSetupDoneComponent,
    ConnectBookingFlowComponent,
    ConnectAgodaFlowComponent,
    ConnectBookingDisclaimerComponent,
    ConnectBookingCredentialsComponent,
    ConnectBookingPricingComponent,
    ConnectSetMarkupComponent,
    ConnectDoneComponent,
    ConnectInviteComponent,
    ConnectAirbnbOfficialFlowComponent,
    ConnectInviteYourHostsComponent,
    AirbnbOfficialConnectionErrorComponent,
    ConnectBookingStartComponent,
    ConnectBookingChooseMethodComponent,
    ConnectBookingPropertyIdsComponent,
    ConnectBookingWidgetComponent,
    ConnectBookingWidgetPendingComponent,
    ConnectBookingReviewPropertiesComponent,
    ConnectBookingSuccessComponent,
    ConnectBookingFailComponent,
    ConnectBookingRequirementsFailComponent,
    ConnectAgodaStartComponent,
    ConnectAgodaInstructionsComponent,
    ConnectAgodaMessagingComponent,
    ConnectAgodaRequirementsComponent,
    ConnectAgodaRequirementsFailComponent,
    ConnectAgodaPropertyIdsComponent,
    ConnectAgodaReviewPropertiesComponent,
    BookingConnectionDocumentationPipe,
    DeniedComponent,
    MergeMatchDropdownComponent,
    ConnectAirbnbFlowComponent,
    DowngradeAirbnbComponent,
  ],
  imports: [CommonModule, ConnectedAccountsRoutingModule, SharedModule, SettingsModule],
})
export class ConnectedAccountsModule {}
